import React from "react";
import { Overlay, Tooltip } from "react-bootstrap"; // ✅ both from react-bootstrap

const DetailCell = ({ row }) => {
  const [show, setShow] = React.useState(false);
  const ref = React.useRef(null);
  const hideTimeout = React.useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(hideTimeout.current);
    setShow(true);
  };

  const handleMouseLeave = () => {
    hideTimeout.current = setTimeout(() => setShow(false), 300);
  };

  const fields = [
    { label: "Material GroupCode", value: row?.materialGroupCode },
    { label: "Material Category",  value: row?.materialCategory },
    { label: "Surface/Paint",      value: row?.unitSurfacePaint },
    { label: "Building Type",      value: row?.buildingType },
    { label: "Components",         value: row?.componentKey },
    { label: "Remarks",            value: row?.remarks },
    { label: "Created By",         value: row?.createdBy },
    { label: "Created Date",       value: row?.createdDate },
    { label: "Updated Date",       value: row?.updatedDate },
  ];

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ display: "inline-block" }}
    >
      <button ref={ref} className="btn btn-light p-1 border-0">
        <i className="bi bi-eye fs-5 text-primary"></i>
      </button>

      <Overlay
        target={ref.current}
        show={show}
        placement="left"
        container={document.body}
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: { offset: [0, 10] },
            },
          ],
        }}
      >
        {(props) => (
          <Tooltip
            {...props}
            id={`tooltip-${row?.documentNumber}`}
            className="custom-tooltip"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div style={{ textAlign: "left" }}>
              {fields.map(({ label, value }) => (
                <div key={label} style={{ marginBottom: "3px" }}>
                  <strong>{label}:</strong> {value || "--"}
                </div>
              ))}
            </div>
          </Tooltip>
        )}
      </Overlay>
    </div>
  );
};

export default DetailCell;
